import React from 'react'
import {Button, Divider, message, Select} from 'antd'
import {GoogleCircleFilled} from '@ant-design/icons'
import {Link, redirect, useNavigate} from 'react-router-dom'
import {instance as userService} from '../../services/UserService'
import {useIntl} from 'react-intl'
import {LoginForm} from './LoginForm'
import './loginPage.less'

export function LoginPage() {
  const navigate = useNavigate()
  const [messageApi, contextHolder] = message.useMessage()
  const intl = useIntl()
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div className="container">
        <Link className="logo" to="/">
          <h1>TerraSketch</h1>
        </Link>
        <h2>{intl.formatMessage({id: 'logIn'})}</h2>
        <LoginForm></LoginForm>
        <Link to="/reset-password">{intl.formatMessage({id: 'forgotPassword'})}?</Link>
        <Divider />
        <Button
          icon={<GoogleCircleFilled />}
          size="large"
          onClick={async () => {
            const result = await userService.signInGoogle()
            if (!result.success) {
              messageApi.open({
                type: 'error',
                content: result.error.message,
              })
            } else {
              navigate('/home')
            }
          }}
        >
          {intl.formatMessage({id: 'logInWithGoogle'})}
        </Button>
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <div>{intl.formatMessage({id: 'byClickingLogInWithGoogle'})} </div>
          <Link to="/policies">{intl.formatMessage({id: 'policyTerrasketch'})}</Link>
        </div>
        <Divider />
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <div>{intl.formatMessage({id: 'ifYouDontHaveAccount'})}</div>
          <Link to="/signup">{intl.formatMessage({id: 'signUp'})}</Link>
          <div>
            <Select
              defaultValue="eng"
              style={{width: 120}}
              onChange={() => {}}
              options={[
                {value: 'eng', label: 'English'},
                {value: 'pl', label: 'Polish'},
                {value: 'ru', label: 'Russian'},
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
